export default __webpack_public_path__ + "static/media/private-equity.2d24f6b5.svg";